<template>
  <div class="bg-slate-middle rounded-xl p-2 fadein xl:w-34 md:w-36 w-48 flex flex-col">
    <div tabindex="0" ref="firstFocus" class="p-px self-end" @pointerup.stop="emit('toggleMainMenu')" @keydown.enter="emit('toggleMainMenu')">
      <img class="w-5 invert rotate-45" :src="Plus" :alt="t('aria-close')" />
    </div>
    <div class="flex flex-col items-start justify-start ml-3 gap-2">
      <LandingpageOption />
      <DashboardOption />
      <slot></slot>
      <LogoutOption />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n'
  import DashboardOption from './DashboardOption.vue'
  import LandingpageOption from './LandingpageOption.vue'
  import LogoutOption from './LogoutOption.vue'
  import Plus from '@/assets/icons/fontawesome/plus-solid.svg'
  import { nextTick } from 'process'
  import { ref, onMounted } from 'vue'

  const { t } = useI18n({})

  const emit = defineEmits<{
    (e: 'toggleMainMenu'): void
  }>()

  const firstFocus = ref()
  onMounted(() => nextTick(() => firstFocus.value?.focus()))
</script>

<style scoped></style>
